import { render } from "./ProductSelect.vue?vue&type=template&id=48aa86b8&ts=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__